import plansAutoSagas from './auto';
import plansProductSagas from './product';

export default [
  ...plansAutoSagas,
  ...plansProductSagas
];
